<template lang="pug">
  ListView(
    v-if='track'
    type='track'
    :progress='track.progress'
    :cover='cover'
    :hide-cover='hideCover'
    :show-controls='showControls'
    :editable-title='editableTitle'
    :checked='checked'
    :active='Boolean(track.active)'
    :running='running'
    :link='disableLink ? "" : `/tracks/${track.id}`'
    :title='track.name || $l10n("NO_NAME")'
    :artists='track.artists'
    :duration='track.duration'
    :removable='removable'
    :disabled='disabled'
    :likes='track.likes'
    :context-menu='contextMenu'
    @play='$emit("play")'
    @pause='$emit("pause")'
    @delete='$emit("delete")'
    @restore='$emit("restore")'
    @like='$emit("like")'
    @unlike='$emit("unlike")'
    @rename='title => $emit("rename", title)'
  )
</template>

<script>
import ListView from "@/components/ListView/ListView";
import { mapGetters } from "vuex";

export default {
  inheritAttrs: false,
  name: "TrackListView",
  props: [
    "showControls",
    "track",
    "playlistId",
    "running",
    "checked",
    "editableTitle",
    "inQueue",
    "disableLink",
    "hideCover",
    "removable",
    "disabled"
  ],
  components: {
    ListView
  },
  computed: {
    ...mapGetters({
      trackInQueue: "queue/inQueue"
    }),
    contextMenu() {
      return this.$contextMenu.create({
        addToQueue: {
          tracks: [this.track.id],
          player: this.$player,
          active: !this.trackInQueue(this.track.id) && this.track.active
        },
        removeFromQueue: {
          track: this.track.id,
          player: this.$player,
          active:
            this.inQueue &&
            this.trackInQueue(this.track.id) &&
            this.track.active
        },
        addToPlaylist: {
          tracks: [this.track.id],
          active: !this.playlistId && this.track.active
        },
        removeFromPlaylist: {
          playlistId: this.playlistId,
          trackId: this.track.id,
          active: Boolean(this.playlistId) && this.track.active
        },
        complain: {
          itemType: "track",
          itemId: this.track.id,
          active: this.track.active
        }
      });
    },
    cover() {
      return this.track.cover ? this.track.cover.small : "";
    }
  }
};
</script>
